import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { MonthCalendar, CalendarLegend } from "@/components/MonthCalendar";
import { useOccupancy } from "@/hooks/queries";
import { addDays, formatRange, monthBounds, parseISODate, startOfMonth, todayISO } from "@/lib/format";

export const BookingCalendar = ({ tripId, duration, value, onChange }) => {
  const [month, setMonth] = useState(() => startOfMonth(value ? parseISODate(value) : new Date()));
  const { data, isFetching } = useOccupancy(tripId, month, duration + 1);
  const occ = data?.occupied || {};
  const today = todayISO();
  const { start, end } = monthBounds(month);

  const baseState = (iso) => {
    if (iso < today) return { state: "past", disabled: true };
    if (!data) return { state: "conflict", disabled: true };
    const o = occ[iso];
    if (o) {
      return o.status === "diblokir"
        ? { state: "blocked", disabled: true, note: "Tanggal ditutup" }
        : { state: "booked", disabled: true, note: "Sudah terisi" };
    }
    for (let i = 1; i < duration; i++) {
      if (occ[addDays(iso, i)]) return { state: "conflict", disabled: true, note: `Trip ${duration} hari bentrok dengan tanggal terisi` };
    }
    return { state: "available" };
  };

  useEffect(() => {
    if (value && data && value >= start && value <= end && baseState(value).state !== "available") onChange(null);
  }, [data, value, duration]); // eslint-disable-line react-hooks/exhaustive-deps

  const rangeEnd = value ? addDays(value, duration - 1) : null;
  const getDay = (iso) => {
    if (value && iso === value) return { state: "selected" };
    if (value && iso > value && iso <= rangeEnd) return { state: "range" };
    return baseState(iso);
  };
  const select = (iso) => {
    if (iso === value) return onChange(null);
    if (baseState(iso).state === "available") onChange(iso);
  };

  return (
    <div id="booking" className="panel scroll-mt-24 p-5 sm:p-7" data-testid="booking-calendar-panel">
      <div className="flex items-center justify-between">
        <p className="overline-label">Langkah 2</p>
        {isFetching && <Loader2 className="h-4 w-4 animate-spin text-neutral-500" />}
      </div>
      <h3 className="mb-6 mt-2 font-display text-2xl">Pilih tanggal berangkat</h3>
      <MonthCalendar month={month} onMonthChange={setMonth} getDay={getDay} onSelect={select} minMonth={new Date()} testId="booking-calendar" />
      <CalendarLegend items={["available", "booked", "blocked", "selected"]} />
      <div className="mt-6 rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm" data-testid="booking-selected-range">
        {value ? (
          <span>
            <span className="text-neutral-500">Jadwal kamu: </span>
            <span className="text-gold-light">{formatRange(value, rangeEnd)}</span>
          </span>
        ) : (
          <span className="text-neutral-500">Belum ada tanggal dipilih</span>
        )}
      </div>
    </div>
  );
};
